<section class="ids-m-2">
  <ids-alert [(show)]="statusService.showTimeLeft" show icon>
    <span> Sua sessão vai encerrar em {{ statusService.timeLeft }} segundos. </span>
    <a href="javascript:void(0)" class="ids-link relogin-btn" (click)="reLogin()">
      Clique aqui para continuar nesse site.</a
    >
  </ids-alert>
</section>
